import { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { reporteDatosApi, reportePDFApi } from '../api';

function StatCard({ label, valor, color }) {
  return (
    <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: '1.25rem', flex: 1, minWidth: 140 }}>
      <div style={{ fontSize: 13, color: '#aaa', marginBottom: 8 }}>{label}</div>
      <div style={{ fontSize: 36, fontWeight: 700, color: color || '#fff', lineHeight: 1 }}>{valor}</div>
    </div>
  );
}

const ESTADOS_IMPL = {
  planificada: { label: 'Planificada', color: '#4a9fd4' },
  en_curso:    { label: 'En curso',    color: '#fbbf24' },
  finalizada:  { label: 'Finalizada',  color: '#4ade80' },
  pausada:     { label: 'Pausada',     color: '#f87171' },
};

const Spinner = ({ color = 'white' }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
      <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
    </path>
  </svg>
);

export default function Reportes() {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [filtrando, setFiltrando] = useState(false);
  const [exportando, setExportando] = useState(false);
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [tituloReporte, setTituloReporte] = useState('');

  const cargar = async (d, h) => {
    if (d !== undefined && h !== undefined) {
      setFiltrando(true);
    } else {
      setCargando(true);
    }
    const desdeVal = d !== undefined ? d : desde;
    const hastaVal = h !== undefined ? h : hasta;
    try {
      const params = {};
      if (desdeVal) params.desde = desdeVal;
      if (hastaVal) params.hasta = hastaVal;
      const res = await reporteDatosApi(params);
      setDatos(res.data);
    } catch(err) { console.error(err); }
    finally { setCargando(false); setFiltrando(false); }
  };

  useEffect(() => { cargar(undefined, undefined); }, []);

  const exportarPDF = async () => {
    setExportando(true);
    try {
      const params = {};
      if (desde) params.desde = desde;
      if (hasta) params.hasta = hasta;
      if (tituloReporte) params.titulo = tituloReporte;
      const res = await reportePDFApi(params);
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `${tituloReporte || 'reporte-euroswiss'}-${desde || 'completo'}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch(err) { alert('Error al generar reporte'); }
    finally { setExportando(false); }
  };

  const tickets = datos?.tickets || [];
  const implementaciones = datos?.implementaciones || [];
  const stats = datos?.stats || {};

  const porEstado    = (e) => tickets.filter(t => t.estado === e).length;
  const porPrioridad = (p) => tickets.filter(t => t.prioridad === p).length;
  const porSistema   = (s) => tickets.filter(t => t.sistema === s).length;

  return (
    <Layout titulo="Reportes">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '1.25rem', flexWrap: 'wrap', gap: 12 }}>
        <p style={{ fontSize: 20, fontWeight: 600, color: '#fff' }}>Reportes</p>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div>
            <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>Desde</div>
            <input type="date" value={desde} onChange={e => setDesde(e.target.value)}
              style={{ padding: '7px 10px', borderRadius: 8, border: '1px solid #2a2a2a', background: '#1a1a1a', color: '#fff', fontSize: 13, outline: 'none' }}/>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>Hasta</div>
            <input type="date" value={hasta} onChange={e => setHasta(e.target.value)}
              style={{ padding: '7px 10px', borderRadius: 8, border: '1px solid #2a2a2a', background: '#1a1a1a', color: '#fff', fontSize: 13, outline: 'none' }}/>
          </div>
          <button onClick={() => cargar(desde, hasta)} disabled={filtrando}
            style={{ padding: '7px 14px', background: '#222', border: '1px solid #333', color: '#aaa', borderRadius: 8, fontSize: 13, cursor: filtrando ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
            {filtrando ? <><Spinner color="#aaa"/> Filtrando...</> : 'Filtrar'}
          </button>
          <button onClick={() => { setDesde(''); setHasta(''); cargar('', ''); }}
            style={{ padding: '7px 14px', background: 'transparent', border: '1px solid #333', color: '#666', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
            Limpiar
          </button>
          <div>
            <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>Titulo del reporte</div>
            <input type="text" value={tituloReporte} onChange={e => setTituloReporte(e.target.value)}
              placeholder="ej: Comite Q1 2026"
              style={{ padding: '7px 10px', borderRadius: 8, border: '1px solid #2a2a2a', background: '#1a1a1a', color: '#fff', fontSize: 13, outline: 'none', width: 180 }}/>
          </div>
          <button onClick={exportarPDF} disabled={exportando}
            style={{ padding: '8px 16px', background: exportando ? '#0c447c' : '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: exportando ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
            {exportando ? <><Spinner/> Generando PDF...</> : '📄 Exportar PDF'}
          </button>
        </div>
      </div>

      {cargando ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3rem', gap: 12, color: '#555' }}>
          <Spinner color="#555"/> Cargando...
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', gap: 12, marginBottom: '1.5rem', flexWrap: 'wrap' }}>
            <StatCard label="Total tickets"    valor={tickets.length} />
            <StatCard label="Abiertos"         valor={porEstado('abierto')}    color="#60a5fa" />
            <StatCard label="En proceso"       valor={porEstado('en_proceso')} color="#fbbf24" />
            <StatCard label="Cerrados"         valor={porEstado('cerrado')}    color="#4ade80" />
            {stats.promedio_horas && <StatCard label="Prom. resolucion" valor={`${stats.promedio_horas}h`} color="#a78bfa" />}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: '1.5rem' }}>
            <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: '1.25rem' }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 14 }}>Tickets por prioridad</p>
              {[
                { label: 'Alta',   valor: porPrioridad('alta'),   color: '#f87171' },
                { label: 'Normal', valor: porPrioridad('normal'), color: '#fbbf24' },
                { label: 'Baja',   valor: porPrioridad('baja'),   color: '#4ade80' },
              ].map(item => (
                <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                  <div style={{ width: 60, fontSize: 12, color: '#bbb' }}>{item.label}</div>
                  <div style={{ flex: 1, background: '#1a1a1a', borderRadius: 999, height: 8, overflow: 'hidden' }}>
                    <div style={{ height: '100%', borderRadius: 999, background: item.color, width: tickets.length > 0 ? `${(item.valor / tickets.length) * 100}%` : '0%', transition: 'width 0.3s' }}/>
                  </div>
                  <div style={{ width: 30, fontSize: 13, color: '#fff', fontWeight: 600, textAlign: 'right' }}>{item.valor}</div>
                </div>
              ))}
            </div>
            <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: '1.25rem' }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 14 }}>Tickets por sistema</p>
              {[
                { label: 'VUEPACS CS', valor: porSistema('vuepacs_carestream'), color: '#4a9fd4' },
                { label: 'VUEPACS Ph', valor: porSistema('vuepacs_philips'),    color: '#a78bfa' },
                { label: 'Otro',       valor: porSistema('otro'),               color: '#888' },
              ].map(item => (
                <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                  <div style={{ width: 90, fontSize: 12, color: '#bbb' }}>{item.label}</div>
                  <div style={{ flex: 1, background: '#1a1a1a', borderRadius: 999, height: 8, overflow: 'hidden' }}>
                    <div style={{ height: '100%', borderRadius: 999, background: item.color, width: tickets.length > 0 ? `${(item.valor / tickets.length) * 100}%` : '0%', transition: 'width 0.3s' }}/>
                  </div>
                  <div style={{ width: 30, fontSize: 13, color: '#fff', fontWeight: 600, textAlign: 'right' }}>{item.valor}</div>
                </div>
              ))}
            </div>
          </div>

          {implementaciones.length > 0 && (
            <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: '1.25rem', marginBottom: '1.5rem' }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 14 }}>Implementaciones</p>
              <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
                {Object.entries(ESTADOS_IMPL).map(([key, val]) => (
                  <div key={key} style={{ background: '#1a1a1a', borderRadius: 8, padding: '10px 16px', textAlign: 'center' }}>
                    <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>{val.label}</div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: val.color }}>{implementaciones.filter(i => i.estado === key).length}</div>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {implementaciones.map(i => {
                  const est = ESTADOS_IMPL[i.estado] || ESTADOS_IMPL.planificada;
                  const progreso = i.etapas_total > 0 ? Math.round((i.etapas_completadas / i.etapas_total) * 100) : 0;
                  return (
                    <div key={i.id} style={{ background: '#1a1a1a', borderRadius: 8, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                      <div style={{ flex: 1, minWidth: 200 }}>
                        <div style={{ fontSize: 13, fontWeight: 500, color: '#fff' }}>{i.titulo}</div>
                        <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>{i.cliente_nombre_libre || '—'}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 140 }}>
                        <div style={{ flex: 1, background: '#111', borderRadius: 999, height: 6, overflow: 'hidden', minWidth: 80 }}>
                          <div style={{ height: '100%', borderRadius: 999, background: progreso === 100 ? '#4ade80' : '#1a6fbb', width: `${progreso}%` }}/>
                        </div>
                        <span style={{ fontSize: 11, color: '#aaa', whiteSpace: 'nowrap' }}>{i.etapas_completadas}/{i.etapas_total}</span>
                      </div>
                      <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 999, background: '#111', color: est.color, fontWeight: 600 }}>{est.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid #1f1f1f', display: 'flex', alignItems: 'center', gap: 8 }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>Todos los tickets ({tickets.length})</p>
              {filtrando && <Spinner color="#555"/>}
            </div>
            {filtrando ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', gap: 10, color: '#555' }}>
                <Spinner color="#555"/> Filtrando tickets...
              </div>
            ) : tickets.length === 0 ? (
              <p style={{ padding: '2rem', textAlign: 'center', color: '#555' }}>No hay tickets en este periodo</p>
            ) : (
              <table>
                <thead>
                  <tr><th>#</th><th>Fecha</th><th>Institucion</th><th>Asunto</th><th>Prioridad</th><th>Estado</th><th>Tecnico</th></tr>
                </thead>
                <tbody>
                  {tickets.map(t => (
                    <tr key={t.id}>
                      <td style={{ color: '#aaa', fontSize: 12 }}>{t.numero}</td>
                      <td style={{ color: '#aaa', fontSize: 11 }}>{new Date(t.created_at).toLocaleDateString('es-AR')}</td>
                      <td>{t.cliente_nombre_db || t.cliente_nombre_libre || '—'}</td>
                      <td>{t.asunto}</td>
                      <td><span className={`badge badge-${t.prioridad}`}>{t.prioridad}</span></td>
                      <td><span className={`badge badge-${t.estado}`}>{t.estado.replace('_', ' ')}</span></td>
                      <td style={{ fontSize: 12, color: '#aaa' }}>
                        {t.tecnico_nombre ? `${t.tecnico_nombre} ${t.tecnico_apellido[0]}.` : <span style={{ color: '#444' }}>Sin asignar</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </Layout>
  );
}